<div [class.rotate-y-180]="showMore()" *ngIf="showFront()"
    class="relative h-[250px] sm:h-[450px] w-[350px] sm:w-[550px] rounded-[36px] shadow-lg cursor-pointer bg-gradient-to-br from-transparent to-black/70">
    <div class="relative w-full h-full rounded-[36px] overflow-hidden">
        <img *ngIf="teamMember.profile_picture" [src]="teamMember.profile_picture" alt=""
            class="absolute inset-0 w-full h-full object-cover" />
        <div class="absolute inset-0 team-card-gradient"></div>
    </div>
    <div class="w-full font-outfit z-1 absolute bottom-[35px] pl-[32px]">
        <div class="gradient-text  font-semibold text-3xl mb-2">{{teamMember.name}}</div>
        <div class="text-lg font-normal mb-6">{{teamMember.role}}</div>
        <app-button buttonText="read more" (clicked)="rotate()"></app-button>
    </div>
</div>
<div [class.rotate-y-180]="!showMore()" *ngIf="!showFront()" (click)="rotate()"
    class="relative h-[250px] sm:h-[450px] w-[350px] sm:w-[550px] rounded-[36px] shadow-lg cursor-pointer bg-gradient-to-br from-transparent to-black/70">
    <div class="relative w-full h-full rounded-[36px] overflow-hidden">
        <img src="/images/team/backgrounds/read-more.png" alt="" class="absolute inset-0 w-full h-full object-cover" />
    </div>
    <div class="w-full font-outfit absolute top-2 sm:top-[50px] px-3 sm:pl-[52px]">
        <div class="font-semibold text-3xl mb-2">{{teamMember.name}}</div>
        <div class="gradient-text text-lg font-normal mb-2 sm:mb-6">{{teamMember.role}}</div>
        <div class="text-base font-inter mb-6 w-full sm:w-[80%] h-[150px] sm:h-[265px] overflow-y-auto text-justify sm:pr-10 hide-scrollbar">
            {{teamMember.about}}</div>
    </div>
</div>